var Class   = require('Class'),
    $       = require('jquery');
/**
 * Модуль перевода фраз. Ожидает на своем уровне директорию "i18n" с переводами (ru.js, en.js ...) вида:
 * module.exports = {
 *     'Фраза': 'Перевод',
 *     ...
 * };
 * Для "ru" Фраза == Перевод
 */
var Lang = Class.extend({
    initialize: function(options){
        var that = this;

        that.options = options;
        that.__debug = [];
        // TODO подумать над необходимостью ограничивать that.options.lng , т.к. фоллбэк на ru язык есть
        // а исходное значение может ещё пригодиться. Но валидация хотя бы регуляркой будет нужна
        that.allowedLanguages = ["ru", "en"];
        if (that.allowedLanguages.indexOf(that.options.lng) == -1) {
            console.warn('Language "'+ that.options.lng + '" is not defined. Switching to "ru"');
            that.options.lng = 'ru';
        }
        // that.options.lng пока что проверяется белым списком. Без белого списка необходима валидация
        try {
            that.data = require('./i18n/' + that.options.lng);
        } catch (err) {
            console.warn('Can\'t find lang "'+ that.options.lng + '". Switching to "ru"');
            that.data = require('./i18n/ru');
        }
        // возможность переопределить переводы из приложения карты
        if (that.options.translations) {
            try {
                $.extend(that.data, that.options.translations);
            } catch (err) {
                console.error(err);
            }
        }
    },
    getLang: function () {
        var that = this;
        return that.options.lng;
    },
    translate: function(phrase){
        var that = this;

        if (phrase in that.data) {
            if (that.data[phrase] === undefined) {
                console.error('Translation error "' + phrase + '"');
                return phrase;
            }
            return that.data[phrase];
        } else {
            if (that.__debug.indexOf(phrase) == -1) {
                console.error('Translation error "' + phrase + '"');
                that.__debug.push(phrase);
            }
        }
        return phrase;
    }
});

module.exports = Lang;


//////////////////
// WEBPACK FOOTER
// ./src/View/Lang.js
// module id = 238
// module chunks = 0